import React, {useEffect, useState} from 'react';
import './index.css';
import webUtils from '../../utils/webUtils';
import classnames from 'classnames';
import useWindowWidth from '../hooks/useWindowWidth';

export default function GoTopButton() {
  const isDemostore = window.location.href.indexOf('/business/showcase') !== -1;
  const width = useWindowWidth();
  const [visible, setVisible] = useState(false);
  const showAtPosition = window.innerHeight * 0.5;
  const stopPosition = isDemostore && webUtils.isMobile() ? 104 : 0;

  useEffect(() => {
    const onScroll = () => setVisible(window.pageYOffset > showAtPosition);
    onScroll();
    window.addEventListener('scroll', onScroll, {passive: true});
    return () => window.removeEventListener('scroll', onScroll);
  }, [showAtPosition]);

  return (
    <div>
      <div
        className={classnames({
          'gotopbutton-for-container': true,
          'gotopbutton-for-container-cn-desktop':
            width > 1024 && webUtils.isCnDomain(),
          'gotopbutton-for-transition': visible,
        })}
        onClick={() => window.scrollTo({top: stopPosition, behavior: 'smooth'})}
      >
        <div>
          <div className="go-top-btn" />
        </div>
      </div>
    </div>
  );
}
